export enum ApplicationStatus {
  All = 'All',
  New = 'New',
  Invited = 'Invited',
  UnderProcess = 'Under Process',
  Rejected = 'Rejected',
  Approved = 'Approved',
  Pending = 'Pending',
  Accepted = 'Accepted',
  Cancelled = 'Cancelled',
  Returned = 'Returned',
  Inactive = 'inactive',
}

export enum ApplicationStatusPost {
  All = 0,
  New = 1,
  Pending = 2,
  Accepted = 3,
  Rejected = 4,
  Cancelled = 5,
  Deleted= 6,
  Archived= 7,
  Returned = 1000,
  Paused = 20000,
  /**
   * Displayed as Deactivated in status dropdown
   */
  Inactive = -3
}

export enum AdminApplicationStatus {
  All = "All",
  PendingAction = "Pending Action",
  Accepted = 'Accepted',
  Rejected = 'Rejected',
  Cancelled = 'Cancelled',
  Open = 'Open',
  Closed = 'Closed',
  None = 'None',
  Deleted= 'Deleted',
  Archived= 'Archived',
  Returned = 'Returned',
  Paused = 'Paused'
}

export enum AdminApplicationStatusPost {
  All,
  PendingAction
}

export enum ApplicationStatuses {
  Invited = 0,
  New = 1,
  Pending = 2,
  Accepted = 3,
  Rejected = 4,
  Cancelled = 5,
  Deleted = 6,
  Archived = 7,
  Returned = 1000,
  Deactivate = -3,
  Inactive = -8,
  Pause = 20000,
  Draft = 1,
  AwaitCondition = 30000
}

export enum StartLinkProcesses{
  Immediate = "Immediate",
  AtStageAction = "AtStageAction"
}

export enum ApplicationClasses {
  Draft = 'draft',
  Invited = 'invited',
  Accepted = 'accepted',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  New = 'new',
  Deleted = 'deleted',
  Archived = 'archived',
  Returned = 'returned',
  Deactivate = 'deactivate',
  Inactive = 'inactive',
}

export enum StageStatus {
  Accepted = 1,
  Rejected = 2
}
